import React, { lazy } from "react";
import { RouteComponentProps } from "@reach/router";
import Page from "components/Page";

const Analytics = lazy(() => import("./Analytics"));

type Props = RouteComponentProps<{ "*": string }>;

export default (props: Props) => (
  <Page>
    <Analytics {...props} />
  </Page>
);
